<div class="modal-content">
  <div class="modal-header">
    <h5 class="modal-title" id="modal7Title">
      {{ title }}
    </h5>
  </div>
  <div class="modal-body py-0 mb-0">
    <p> {{ message }} </p>
  </div>
  <div class="modal-footer">
    <button class="btn btn-sm btn-outline-secondary" type="button" (click)="onClickCancel()">
      {{ cancelButtonLabel }}
    </button>
    <button class="btn btn-primary btn-sm" type="button" (click)="onClickConfirm()">
      {{ confirmButtonLabel }}
    </button>
  </div>
</div>